import React, { Component, ReactNode } from 'react';
import { formatClassName } from '../../utils';

interface ToolbarProps {
  children?: ReactNode;
  toolbarClass?: string;
}

/** This renders a toolbar (generally used in the page header) that contains
 *  search and filters */
export class Toolbar extends Component<ToolbarProps> {
  render() {
    const { toolbarClass } = this.props;
    const toolbarClassName = formatClassName(['page-toolbar', toolbarClass]);

    return (
      <div className={toolbarClassName} data-page-toolbar={true}>
        {this.props.children}
      </div>
    );
  }
}
